const dayjs = require('dayjs');
const isSameOrAfterDayJs = require('dayjs/plugin/isSameOrAfter');
const isSameOrBeforeDayJs = require('dayjs/plugin/isSameOrBefore');

dayjs.extend(isSameOrBeforeDayJs);
dayjs.extend(isSameOrAfterDayJs);

function addSeconds(seconds, date = new Date()) {
  date.setTime(date.getTime() + seconds * 1000);
  return date;
}

function isAfter(valueToCompare, valueToCompareTo) {
  return compareDate(valueToCompare, valueToCompareTo, 'isAfter');
}

function isSameOrAfter(valueToCompare, valueToCompareTo) {
  return compareDate(valueToCompare, valueToCompareTo, 'isSameOrAfter');
}

function isBefore(valueToCompare, valueToCompareTo) {
  return compareDate(valueToCompare, valueToCompareTo, 'isBefore');
}

function isSameOrBefore(valueToCompare, valueToCompareTo) {
  return compareDate(valueToCompare, valueToCompareTo, 'isSameOrBefore');
}

function compareDate(valueToCompare, valueToCompareTo, operator) {
  const convertedValueToCompareTo =
    typeof valueToCompareTo === 'string'
      ? dayjs(valueToCompareTo)
      : dayjs()[valueToCompareTo.method](valueToCompareTo.quantity, valueToCompareTo.unit);
  return dayjs(valueToCompare)[operator](convertedValueToCompareTo, valueToCompareTo.accuracyUnit);
}

function isValidDate(date) {
  // https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date
  // eslint-disable-next-line no-restricted-globals
  return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}

module.exports = {
  addSeconds,
  compareDate,
  isValidDate,
  isAfter,
  isSameOrAfter,
  isBefore,
  isSameOrBefore
};
